// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"a9-z","displaySixCardTiles":"b9-z"};